// import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import SmartGovernanceVerificationLogo from './_smartGovernanceVerificationLogo';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

const PREFIX = '_pageHeader';

const classes = {
  column: `${PREFIX}-column`,
  logoContainer: `${PREFIX}-logoContainer`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  marginTop: 15,
  [`& .${classes.column}`]: {
    flex: 1,
  },

  [`& .${classes.logoContainer}`]: {
    '& > *': {
      marginLeft: 'auto',
    },
  },
}));

interface IProps {
  name: string;
  address: string;
  companyRegistrationNumber: string;
  isSmartGovVerified: boolean;
}

export default function PageHeader(props: IProps): JSX.Element {
  const { t } = useTranslation('default');
  const { name, address, companyRegistrationNumber, isSmartGovVerified } = props;
  return (
    <Root>
      <div className={classes.column}>
        <Typography variant="h5" gutterBottom color="secondary">
          {name}
        </Typography>
        <div style={{ marginTop: 5 }}>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold', m: 0, p: 0 }}>
            {`${t('registration-number')}: ${companyRegistrationNumber}`}
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ m: 0, p: 0 }}>
            {address}
          </Typography>
        </div>
      </div>
      <Box className={classes.column}>
        <div className={classes.logoContainer}>
          <SmartGovernanceVerificationLogo active={isSmartGovVerified} align="right" />
        </div>
      </Box>
    </Root>
  );
}
